import { useNavigate } from "react-router-dom";
import ConcreteEmission from "../../components/ConcreteEmission/ConcreteEmission";
import "../PageCommon.css";
import "./EmbodiedEmission.css";
import { useEffect } from "react";

const ConcreteEmbodiedEmissionPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
      if (!localStorage.getItem('token')) {
        navigate('/signin');
      }
  }, [navigate]);
  
  return (
    <div className="page__container">
      <div className="page__body">
          <ConcreteEmission />
      </div>
    </div>
  );
}

export default ConcreteEmbodiedEmissionPage;